import React, { useEffect } from "react";

import { useAppType, useInView } from "utils";

import { Col, CourseCard, ErrorBoundary, Row } from "components";

export const CourseResults = ({ loadMore, courses, loadingMore, searching, loading, noMore }) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: false,
    trackVisibility: true,
    delay: 100,
  });
  const appType = useAppType();

  useEffect(() => {
    if (inView) {
      loadMore();
    }
  }, [inView, loadMore]);

  return (
    <ErrorBoundary>
      {appType.mobile ? (
        <Row>
          <Col className="course-result-container">
            {courses.map((course, i) => (
              <div key={i} className="course-container">
                <CourseCard course={course} />
              </div>
            ))}
          </Col>
        </Row>
      ) : (
        <Row>
          <Col className="course-result-container">
            {courses.map((course, i) => (
              <div key={i} className="course-container">
                <CourseCard course={course} />
              </div>
            ))}
          </Col>
        </Row>
      )}
      {!noMore && !loadingMore && !searching && !loading && <div ref={ref} />}
    </ErrorBoundary>
  );
};
